// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { openSnackbar } from './notify';
import { displayBackdrop, hideBackdrop } from './loading';

const API_URL = process.env.REACT_APP_API_URL;

// Define a service using a base URL and expected endpoints
export const galleryService = createApi({
    reducerPath: 'galleryService',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    tagTypes: ['GALLERY'],
    endpoints: (builder) => ({
        getGalleryList: builder.query({
            query: () => `gallery`,
            providesTags: [{ type: 'GALLERY', id: 'all-gallery' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
            transformResponse: (response) => response.data,
        }),
        updateGallery: builder.mutation({
            query: (initialPost) => ({ url: 'gallery', method: 'PUT', body: initialPost }),
            invalidatesTags: [{ type: 'GALLERY', id: 'all-gallery' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetGalleryListQuery, useUpdateGalleryMutation } = galleryService;